// extracted by mini-css-extract-plugin
module.exports = {"list":"OptionList_list_T3Lb7","half":"OptionList_half_3Y5BC","quater":"OptionList_quater_1hhzW","active":"OptionList_active_fcH91"};